import {
	canonical,
	capitalizeFirstLetter,
	generateBreadcrumbStructuredDataMarkup,
} from "@/common/functions";

export default function() {
	if (this.isError) {
		return {
			title: this.$t("WordscapesErrorPageMetaTitle"),
			meta: [
				{
					name: "description",
					content: this.$t("WordscapesErrorPageMetaDescription"),
				},
			],
		};
	}

	if (!this.levelInfo) return {};

	const words =
		this.levelInfo.words.length > 3
			? this.levelInfo.words.slice(0, 3)
			: this.levelInfo.words;

	const obj = words.reduce((acc, item, index) => {
		acc[`LevelWord_${index + 1}`] = capitalizeFirstLetter(
			item.toLowerCase()
		);
		return acc;
	}, {});

	let content = this.$t("WordscapesLevelPageMetaDescription", {
		LevelNumber: this.$route.params.level,
		PackName: capitalizeFirstLetter(this.$route.params.pack),
		...obj,
	});

	if (this.levelInfo.words.length < 3) {
		content = content.replace(", , and more", "");
	}

	return {
		title: this.$t("WordscapesLevelPageMetaTitle", {
			LevelNumber: this.$route.params.level,
			PackName: capitalizeFirstLetter(this.$route.params.pack),
			GroupName: capitalizeFirstLetter(this.$route.params.group),
		}),
		meta: [
			{
				name: "description",
				content,
			},
		],
		script: [
			{
				type: "application/ld+json",
				json: generateBreadcrumbStructuredDataMarkup([
					{
						name: capitalizeFirstLetter(this.levelInfo.world),
						path: this.$t("BreadcrumbWordscapesGroupPageUrl", {
							GroupName: this.$route.params.group,
						}),
					},
					{
						name: capitalizeFirstLetter(this.levelInfo.stage),
						path: this.$t("BreadcrumbWordscapesPackPageUrl", {
							GroupName: this.$route.params.group,
							PackName: this.$route.params.pack,
						}),
					},
					{
						name: this.$route.params.level,
						path: this.$route.path,
					},
				]),
			},
		],
		link: [canonical(this.$route)],
	};
}
